import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--nx-navy)',
        gap: 16,
        fontFamily: 'var(--font-body)',
      }}
    >
      <div
        style={{
          fontSize: 72,
          fontFamily: 'Syne, sans-serif',
          fontWeight: 800,
          background: 'linear-gradient(135deg, #1A6CF6, #6D28D9)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          lineHeight: 1,
        }}
      >
        404
      </div>
      <p style={{ fontSize: 16, color: 'var(--nx-text-secondary)', margin: 0 }}>
        The page you're looking for doesn't exist.
      </p>
      <button
        onClick={() => navigate(-1)}
        style={{
          marginTop: 8,
          padding: '10px 24px',
          background: 'linear-gradient(135deg, #1A6CF6, #6D28D9)',
          color: '#fff',
          border: 'none',
          borderRadius: 10,
          fontSize: 14,
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Go Back
      </button>
      <p style={{ marginTop: 16, fontSize: 11, color: 'var(--nx-text-muted)' }}>
        © {new Date().getFullYear()} Pentagon Analytics. All rights reserved.
      </p>
    </div>
  );
};

export default NotFoundPage;
